export default "__VITE_ASSET__iiJmJes8__"